import { render, staticRenderFns } from "./BackSaveButtons.vue?vue&type=template&id=6b791856&"
import script from "./BackSaveButtons.vue?vue&type=script&lang=js&"
export * from "./BackSaveButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports